<template>
    <div class="tabs">
        <div class="relative">
            <slot :toggle="toggle" :active="active" :opened="opened" />

            <transition name="fade">
                <slot name="items" :active="active" :opened="opened" :close="close" />
            </transition>
        </div>
    </div>
</template>

<script>

export default {
    name: 'app-tabs-wrapper',

    props: {
        default: String,
    },

    data: () => ({
        active: '',
        opened: ''
    }),

    mounted() {
        this.active = this.default ? this.default : '';
    },

    methods: {
        toggle(name) {
            this.active = name;
            this.opened = name;
            this.$root.buyTickets.opened = name;
        },

        close() {
            event.preventDefault();
            
            this.opened = '';
            this.$root.buyTickets.opened = '';
        }
    },
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// resources/js/components/Tabs/Wrapper.vue